<template>
  <button
    type="button"
    :class="[
      rounded ? 'box_button_rounded inline rounded-full' : customSize,
      customClass ? customClass : theme,
      bold ? 'font-bold' : 'font-medium',
      { disabledStyle: disabled },
    ]"
    class="focus:outline-none inline-flex items-center justify-center rounded-md text-sm shadow-lg transition-all duration-150 ease-in-out"
    :disabled="disabled"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "ontick-button",
  props: {
    rounded: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
    },
    customClass: {
      type: String,
    },
    size: {
      type: String,
      default: "normal",
      validator: function (value) {
        return ["normal", "small", "medium"].indexOf(value) !== -1;
      },
    },
    disabled: {
      type: Boolean,
    },
    disabledStyle: {
      type: String,
      default:
        "bg-ontick-steel-200 dark:bg-ontick-steel-500 text-gray-500 cursor-not-allowed",
    },
    bold: {
      type: Boolean,
    },
  },

  computed: {
    theme() {
      // 'Object literal' pattern (switch)
      let styleList = {
        primary:
          "dark:bg-ontick-blue-900 bg-ontick-blue-700 dark:text-gray-300 text-gray-50  hover:bg-ontick-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-ontick-blue-500",
        secondary:
          "bg-ontick-green-500 text-gray-800 hover:bg-ontick-green-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-ontick-green-600",
        third: "bg-ontick-red-800 text-gray-300",
        fourth: "bg-ontick-ontick-carbon-500 text-gray-400 hover:text-white",
        cinza:
          "dark:bg-ontick-steel-700 bg-ontick-steel-100 dark:text-gray-300 text-ontick-carbon-900  border-2 border-ontick-steel-300 dark:border-ontick-graphite-500 dark:hover:bg-ontick-steel-600 hover:bg-ontick-steel-300",
        steel: "bg-ontick-steel-500 text-gray-300 hover:bg-ontick-steel-600",
        transparent:
          "bg-transparent text-gray-500 border border-gray-500 dark:text-gray-400 dark:border-gray-400",
        red: "bg-ontick-red-700 hover:bg-ontick-red-600 text-gray-50 dark:text-gray-300",
        "ghost-green":
          "bg-transparent text-ontick-green-900 dark:text-ontick-green-600 border-ontick-green-900 dark:border-ontick-green-600 border",
      };
      if (this.disabled) {
        return this.disabledStyle;
      } else {
        return styleList[this.color] || styleList.primary;
      }
    },
    customSize() {
      return {
        "px-6 py-3": this.size == "normal",
        "px-2 py-2": this.size == "small",
        "md:px-3 lg:px-1 px-2 py-3": this.size == "medium",
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.box_button_rounded {
  width: 30px;
  height: 30px;
}
</style>
